module.exports = __webpack_public_path__ + "img/sended-mail.c9fd563a.svg";